import React, {Component} from 'react'
import {observable} from 'mobx'
import {observer} from 'mobx-react'
import classNames from 'classnames'

import SpanLink from 'lib/control/SpanLink'
import Icon from 'lib/struct/icon/Icon';

import Checkbox from '../../control/DependentCheckbox'

import styles from './YandexCategoryMappingTable.less'

@observer export default class YandexCategoryMappingTable extends Component {
    constructor(props) {
        super(props)

        /** @type {ProfileSettingsContext} */
        const context = this.props.context

        const expanded_ids = observable(new Map())
        expanded_ids.set(0, true)

        const with_children_ids = new Map()
        /** @type {Category} */
        let previous = null
        for (const category of context.categories) {
            if (previous && category.isChildOf(previous)) {
                with_children_ids.set(previous.id, true)
            }

            previous = category
        }

        this.state = {
            expanded_ids: expanded_ids,
            with_children_ids: with_children_ids,
        }
    }

    render() {
        const {expanded_ids, with_children_ids} = this.state
        const {isCategoryIdSelected} = this.props

        /** @type {ProfileSettingsContext} */
        const context = this.props.context
        const profile = context.profile

        /** @type {Array<Category>} */
        const shown_categories = []

        let category_to_skip_children_for = null
        for (const category of context.categories) {
            if (category_to_skip_children_for) {
                if (!category.isChildOf(category_to_skip_children_for)) {
                    shown_categories.push(category)
                    category_to_skip_children_for = expanded_ids.has(category.id)
                        ? null
                        : category
                }
            } else {
                shown_categories.push(category)
                category_to_skip_children_for = expanded_ids.has(category.id)
                    ? null
                    : category
            }
        }

        return (
            <div>
                <div>
                    <SpanLink onClick={this.collapseAll} pseudo>Свернуть все</SpanLink>
                    {' | '}
                    <SpanLink onClick={this.expandAll} pseudo>Развернуть все</SpanLink>
                </div>

                <div className={styles['categories__table-wrapper']}>
                    <table className="zebra">
                        <tbody>
                        {
                            shown_categories.map(category => (
                                <tr
                                    key={category.id}
                                    onClick={e => this.toggleCategoryIdSelection(e, category.id)}
                                    className={styles['categories__row']}
                                >
                                    <td>
                                        <div
                                            style={{paddingLeft: `${10 * category.depth}px`}}
                                            className={styles['categories__row-block']}
                                        >
                                            {
                                                with_children_ids.has(category.id) ? (
                                                    <SpanLink
                                                        onClick={e => this.toggleNodeExpansion(e, category.id)}
                                                        className={classNames(styles['categories__expand-link'], styles['categories__before-checkbox-space'])}
                                                    >
                                                        <span className={classNames({'hidden': expanded_ids.has(category.id)})}>
                                                            <Icon name='darr' />
                                                        </span>
                                                        <span className={classNames({'hidden': !expanded_ids.has(category.id)})}>
                                                            <Icon name='uarr' />
                                                        </span>
                                                    </SpanLink>
                                                ) : (<span className={styles['categories__before-checkbox-space']}/>)
                                            }

                                            <Checkbox
                                                checked={isCategoryIdSelected(category.id)}
                                                onChange={() => {
                                                }}
                                                onClick={e => this.toggleCategoryIdSelection(e, category.id)}
                                                onLabelClick={e => this.toggleCategoryIdSelection(e, category.id)}
                                                state={context.form_state}
                                            >
                                                {category.name}
                                            </Checkbox>
                                        </div>
                                    </td>
                                    <td>
                                        → {context.getYandexCategoryName(profile.category_yandex_category_mapping.get(category.id))}
                                    </td>
                                </tr>
                            ))
                        }
                        </tbody>
                    </table>
                </div>
            </div>
        )
    }

    expandAll = () => {
        const {expanded_ids} = this.state
        /** @type {ProfileSettingsContext} */
        const context = this.props.context

        for (const category of context.categories) {
            expanded_ids.set(category.id, true)
        }
    }

    collapseAll = () => {
        const {expanded_ids} = this.state

        expanded_ids.clear()
        expanded_ids.set(0, true)
    }

    toggleNodeExpansion = (event, category_id) => {
        const {expanded_ids} = this.state

        event.stopPropagation()

        if (expanded_ids.has(category_id)) {
            expanded_ids.delete(category_id)
        } else {
            expanded_ids.set(category_id, true)
        }
    }

    toggleCategoryIdSelection(event, category_id) {
        /** @type {ProfileSettingsContext} */
        const context = this.props.context
        const {isCategoryIdSelected, toggleCategoryIdSelection} = this.props

        toggleCategoryIdSelection(category_id)

        const is_selected = isCategoryIdSelected(category_id)

        if (event.target.type !== 'checkbox') {
            event.preventDefault()
        }
        event.stopPropagation()

        if (event.shiftKey) {
            let t = null

            for (const category of context.categories) {
                if (category.id === category_id) {
                    t = category
                } else if (t) {
                    if (!category.isChildOf(t)) {
                        break
                    }

                    if (isCategoryIdSelected(category.id) !== is_selected) {
                        toggleCategoryIdSelection(category.id)
                    }
                }
            }
        }
    }
}